<template>
<PopupWindow v-if="isVisiblePopup" :key="modal" :popupName="modal.popupName" :header="modal.header" :info="modal.info" :buttonText="modal.button" :callback="modal.callback" :color="modal.color" :buttonText2="modal.button2"></PopupWindow>
<div class="d-flex" style="min-height: 42vw; width: fit-content">
    <div class="flex-item item_2_space item_space_border_left" style="min-width: 5vw;max-width: 5vw;"></div>
    <div class="flex-item item_8" style="margin-top: 10px;">
        <div style="width: max-content;" id="main_slider_div">
            <div class="d-flex" style="user-select: none;">
                <div class="flex-item section" style="text-align: left; width: 300px;" id="non_processed_button">Необработанные <span id="notWRequests" class="summaryRequests">8</span></div>
                <div class="flex-item section" style="text-align: left;" id="in_pipeline_button">В работе <span id="inWorkRequests" class="summaryRequests">3</span></div>
            </div>
            <div class="d-flex" style="margin-bottom: 10px; margin-top: 10px;">
                <div class="flex-item item_8" id="parent" style="background: #E0E0E0; height: 4px;">
                    <div id="child" style="background: #4BACE3; height: 100%; width: 100px; margin-left: 30px;"></div>
                </div>
            </div>
        </div>
        <div class="d-flex" id="order_types" style="margin-top: 20px; width: 90vw; min-width: fit-content;">
            <span id="superviser__control" class="superviser__control" v-on:click="reRender($event)">
                <label id="filter__head" class="filter__head">
                    <img v-on:click="flexFilters()"  src="../assets/IMGS/SVG/filterIco.svg" alt="filter" style="cursor: pointer;">
                    <a id="filter_zone_item" v-on:click="reFiltering()" style="cursor: pointer; color: #FF8A90; border-bottom: 2.9px dotted #FF8A90;">Очистить</a>
                </label>
                <label id="filter_status" class="fliter__status">
                    <a class="head__text">Статус заказа</a>
                    <div id="order_status_select_box" class="select-box custom-select">
                        <div class="myarrow"></div>
                        <div id="order_status_selected" class="selected_option" v-on:click.stop="tools.selectedOpenClose('order_status')">
                            <p id="order_status" class="selected_text">Любой</p>
                            <p id="order_status_index" class="selected_hidden_index">-1</p>
                        </div>
                        <div id="order_status_options" class="options" v-on:click.stop="reRender()">
                            <div id="order_status_option1" class="option" v-on:click="tools.selectOptionsChoose('order_status', 1, 6)">
                                <p id="order_status_option1_text" class="option_text">Любой</p>
                            </div>
                            <div id="order_status_option2" class="option" v-on:click="tools.selectOptionsChoose('order_status', 2, 6)">
                                <p id="order_status_option2_text" class="option_text">Подтвержден</p>
                            </div>
                            <div id="order_status_option3" class="option" v-on:click="tools.selectOptionsChoose('order_status', 3, 6)">
                                <p id="order_status_option3_text" class="option_text">Запланирован</p>
                            </div>
                            <div id="order_status_option4" class="option" v-on:click="tools.selectOptionsChoose('order_status', 4, 6)">
                                <p id="order_status_option4_text" class="option_text">Выезд</p>
                            </div>
                            <div id="order_status_option5" class="option" v-on:click="tools.selectOptionsChoose('order_status', 5, 6)">
                                <p id="order_status_option5_text" class="option_text">Выполняется</p>
                            </div>
                            <div id="order_status_option6" class="option" v-on:click="tools.selectOptionsChoose('order_status', 6, 6)">
                                <p id="order_status_option6_text" class="option_text">Приостановлен</p>
                            </div>
                        </div>
                    </div>
                </label>
                <label id="filter__time" class="filter__time">
                    <a class="head__text">Дата и время</a>
                    <span style="display: flex; flex-flow:column; justify-content: center; align-items: center;">
                        <ul class="time__list">
                            <label style="width: 35%; height: 100%;" v-on:click="setNowDay()" class="check__container__radio">
                                <input id='date1' type="radio" name="radio_date">
                                <div class="background_checkradio date_check"><span style="padding-left: 5px; padding-right:5px;">Сегодня</span></div>
                            </label>
                            <label style="width:35%; height: 100%;" v-on:click="setLastWeek()" class="check__container__radio">
                                <input id='date2' type="radio" name="radio_date">
                                <div class="background_checkradio date_check"><span style="padding-left: 5px; padding-right:5px;">Неделя</span></div>
                            </label>
                            <label style="width: 35%; height: 100%;" v-on:click="setNowMonth()" class="check__container__radio">
                                <input id='date3' type="radio" name="radio_date">
                                <div class="background_checkradio date_check"><span style="padding-left: 5px; padding-right:5px;">Месяц</span></div>
                            </label>
                        </ul>
                        <div id="" class="time__back">
                            <label for='first__date' class="date__container">
                                <input id="first__date" v-on:keyup="tools.inputDateKeyUp('first__date')" v-on:blur="tools.inputDateLoseFocus('first__date')"
                                    type="date" class="date-picker" pattern="(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012])" style="padding-right: 0px;">
                                <input id="second__date" v-on:keyup="tools.inputDateKeyUp('first__date')" v-on:blur="tools.inputDateLoseFocus('first__date')"
                                    type="date" class="date-picker" pattern="(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012])" style="padding-right: 0px;">
                            </label>
                            <label for='first__time' class="date__container">
                                <input style="padding-right: 0px;" id="first__time" v-on:click="getNowDate('first__time')" type="time" class="date-picker" >
                                <input style="padding-right: 0px;" id="second__time" v-on:click="getNowDate('second__time')" type="time" class="date-picker" >
                            </label>
                        </div>
                    </span>
                </label>
                <label id="filter__type" class="filter__type" for="">
                    <a class="head__text">Вид услуги</a>
                    <label for='veh__check' class="type__list">
                        <label class="check__container__radio ">
                            <input id='veh__check_1' class="svg_states" type="radio" name="radio_veh" checked>
                            <img class="patient-icon default-icon" style="height:17px;width:19px" src="../assets/IMGS/SVG/car/car.svg" alt="car">
                            <img class="patient-icon hover-icon" style="height:17px;width:19px" src="../assets/IMGS/SVG/car/car_hover.svg" alt="car_hover">
                            <img class="patient-icon checked-icon" style="height:17px;width:19px" src="../assets/IMGS/SVG/car/car_checked.svg" alt="car_checked">
                            <img class="patient-icon checked-hover-icon" style="height:17px;width:19px" src="../assets/IMGS/SVG/car/car_checked_hover.svg" alt="car_checked_hover">
                            <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/car.svg"> -->
                            <div class="background_checkradio"></div>
                        </label>
                        <label class="check__container__radio">
                            <input id='veh__check_2' class="svg_states" type="radio" name="radio_veh">
                            <img class="patient-icon default-icon" style="height:18px;width:16px" src="../assets/IMGS/SVG/railway/railway.svg" alt="railway">
                            <img class="patient-icon hover-icon" style="height:18px;width:16px" src="../assets/IMGS/SVG/railway/railway_hover.svg" alt="railway_hover">
                            <img class="patient-icon checked-icon" style="height:18px;width:16px" src="../assets/IMGS/SVG/railway/railway_checked.svg" alt="railway_checked">
                            <img class="patient-icon checked-hover-icon" style="height:18px;width:16px" src="../assets/IMGS/SVG/railway/railway_checked_hover.svg" alt="railway_checked_hover">
                            <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/railway.svg"> -->
                            <div class="background_checkradio"></div>
                        </label>
                        <label class="check__container__radio">
                            <input id='veh__check_3' class="svg_states" type="radio" name="radio_veh">
                            <img class="patient-icon default-icon" style="height:18px;width:18px" src="../assets/IMGS/SVG/airplane/airplane.svg" alt="airplane">
                            <img class="patient-icon hover-icon" style="height:18px;width:18px" src="../assets/IMGS/SVG/airplane/airplane_hover.svg" alt="airplane_hover">
                            <img class="patient-icon checked-icon" style="height:18px;width:18px" src="../assets/IMGS/SVG/airplane/airplane_checked.svg" alt="airplane_checked">
                            <img class="patient-icon checked-hover-icon" style="height:18px;width:18px" src="../assets/IMGS/SVG/airplane/airplane_checked_hover.svg" alt="airplane_checked_hover">
                            <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/airplane.svg"> -->
                            <div class="background_checkradio"></div>
                        </label>
                        <label class="check__container__radio">
                            <input id='veh__check_4' class="svg_states" type="radio" name="radio_veh">
                            <img class="patient-icon default-icon" style="height:17px;width:30px" src="../assets/IMGS/SVG/boat/boat.svg" alt="boat">
                            <img class="patient-icon hover-icon" style="height:17px;width:30px" src="../assets/IMGS/SVG/boat/boat_hover.svg" alt="boat_hover">
                            <img class="patient-icon checked-icon" style="height:17px;width:30px" src="../assets/IMGS/SVG/boat/boat_checked.svg" alt="boat_checked">
                            <img class="patient-icon checked-hover-icon" style="height:17px;width:30px" src="../assets/IMGS/SVG/boat/boat_checked_hover.svg" alt="boat_checked_hover">
                            <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/boat.svg"> -->
                            <div class="background_checkradio"></div>
                        </label>
                    </label>
                    <label for='type__check' class="type__back">
                        <div class="container__type">
                            <label class="checkbox">
                                <div class="check__container">
                                    <input id='type__check_1' type="radio" name="radio_type" checked>
                                    <span class="checkmark"></span>
                                </div>
                                <a class="checkmark_text" style="width: 90px;font-size: 13px;">Все услуги</a>
                            </label>
                            <label class="checkbox">
                                <div class="check__container">
                                    <input id='type__check_2' type="radio" name="radio_type">
                                    <span class="checkmark"></span>
                                </div>
                                <a class="checkmark_text" style="width: 90px;font-size: 13px;">Санитарная перевозка</a>
                            </label>
                            <label class="checkbox">
                                <div class="check__container">
                                    <input id='type__check_3' type="radio" name="radio_type">
                                    <span class="checkmark"></span>
                                </div>
                                <a class="checkmark_text" style="width:120px;font-size: 13px;">Скорая помощь</a>
                            </label>
                            <label class="checkbox">
                                <div class="check__container">
                                    <input id='type__check_4' type="radio" name="radio_type">
                                    <span class="checkmark"></span>
                                </div>
                                <a class="checkmark_text" style="width: 90px;font-size: 13px;">Реанимация</a>
                            </label>
                        </div>
                    </label>
                </label>
                <label id="filter__patient" class="filter__patient" for="">
                    <a class="head__text">Пациент</a>
                    <form class="container__patient">
                        <label style="width: 77px;"  class="check__container__radio">
                            <input id='patient__check_1' class="svg_states" type="checkbox" name="checkbox">
                            <img class="patient-icon default-icon" style="height:18px;width:13px" src="../assets/IMGS/SVG/invalid/invalid.svg" alt="invalid">
                            <img class="patient-icon hover-icon" style="height:18px;width:13px" src="../assets/IMGS/SVG/invalid/invalid_hover.svg" alt="invalid_hover">
                            <img class="patient-icon checked-icon" style="height:18px;width:13px" src="../assets/IMGS/SVG/invalid/invalid_checked.svg" alt="invalid_checked">
                            <img class="patient-icon checked-hover-icon" style="height:18px;width:13px" src="../assets/IMGS/SVG/invalid/invalid_checked_hover.svg" alt="invalid_checked_hover">
                            <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/invalidPeople.svg"> -->
                            <div class="background_checkradio"></div>
                        </label>
                        <a class="item__split"></a>
                        <label style="width: 77px;"   class="check__container__radio">
                            <input id='patient__check_2' class="svg_states" type="checkbox" name="checkbox">
                            <img class="patient-icon default-icon" style="height:18px;width:10px" src="../assets/IMGS/SVG/pregnant/pregnant.svg" alt="pregnant">
                            <img class="patient-icon hover-icon" style="height:18px;width:10px" src="../assets/IMGS/SVG/pregnant/pregnant_hover.svg" alt="pregnant_hover">
                            <img class="patient-icon checked-icon" style="height:18px;width:10px" src="../assets/IMGS/SVG/pregnant/pregnant_checked.svg" alt="pregnant_checked">
                            <img class="patient-icon checked-hover-icon" style="height:18px;width:10px" src="../assets/IMGS/SVG/pregnant/pregnant_checked_hover.svg" alt="pregnant_checked_hover">
                            <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/pregnantPeople.svg"> -->
                            <div class="background_checkradio"></div>
                        </label>
                        <a class="item__split"></a>
                        <label style="width: 77px;"  class="check__container__radio">
                            <input id='patient__check_3' class="svg_states" type="checkbox" name="checkbox">
                            <img class="patient-icon default-icon" style="height:17px;width:21px" src="../assets/IMGS/SVG/child/child.svg" alt="child">
                            <img class="patient-icon hover-icon" style="height:17px;width:21px" src="../assets/IMGS/SVG/child/child_hover.svg" alt="child_hover">
                            <img class="patient-icon checked-icon" style="height:17px;width:21px" src="../assets/IMGS/SVG/child/child_checked.svg" alt="child_checked">
                            <img class="patient-icon checked-hover-icon" style="height:17px;width:21px" src="../assets/IMGS/SVG/child/child_checked_hover.svg" alt="child_checked_hover">
                            <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/child.svg"> -->
                            <div class="background_checkradio"></div>
                        </label>
                    </form>
                </label>
                <label id="filter__region" class="filter__region">
                    <div class="container__region">
                        <a class="region__text">Только мой регион</a>
                        <div class="container__checkbox">
                            <input class="toggle__checkbox" type="checkbox" id="toggle_region"/>
                            <div class="toggle__container">
                                <label class='item__toggle' for="toggle"></label>
                            </div>
                        </div>
                    </div>
                </label>
                <label id="filter__adress" class="filter__adress">
                    <div class="container__filter">
                        <div class="container-1">
                            <span class="icon"><i class="search__icon"></i></span>
                            <input type="search" id="search_adress" list="search_adress_datalist" placeholder="Адрес" />
                        </div>
                    </div>
                </label>
            </span>
            <div class="d-flex" id="non_processed_block" style=" width: 100%; color: #747474;">
                <div class="flex-item item_6" style="padding-left: 10px; flex-grow: 6;">
                    <div style="flex-direction: row; display: flex; text-align: left; font-weight: 400; font-size: 12px; line-height: 16px; padding: 15px;">
                        <div style="width: 5%;">No / Время</div>
                        <div style="width: 15%;">Когда</div>
                        <div style="width: 30%;" id="whereFromToDiv">Откуда/Куда</div>
                        <div style="width: 25%;">Пациент/Транспорт</div>
                        <div style="width: 5%; text-align: center;">Сопровождающие</div>
                    </div>
                    <div v-if="!has_loaded_once" class="loading_text">
                        Данные загружаются, пожалуйста, подождите
                    </div>
                    <div v-else id="non_processed_orders">
                        <div v-for="order in new_orders" :key="'non_processed_orders_element'+order.id" :id="'non_processed_orders_element'+order.id">
                            <span class="superviser__history_item">
                                <div class="container__history">
                                    <div class="container__itemID">
                                        <template v-if="order.is_return == false">
                                            <div style='padding-bottom: 6px;' class="itemID">{{ order.id }}</div>
                                            <div class="itemID__time">{{ order.time }}</div>
                                        </template>
                                        <template v-else>
                                            <div style='padding-bottom: 6px;' class="itemID">{{ order.id }}</div>
                                            <div style='padding-bottom: 28px;' class="itemID__time">{{ order.time }}</div>
                                        </template>
                                    </div>
                                    <div class="container__date">
                                        <template v-if="order.is_return == false">
                                            <div style='padding-bottom: 28px;' class="date__item">{{ order.datetime_from }}</div>
                                        </template>
                                        <template v-else-if="order.is_wait == true">
                                            <div style='padding-bottom: 56px;' class="date__item">{{ order.datetime_from }}</div>
                                        </template>
                                        <template v-else>
                                            <div style='padding-bottom: 34px;' class="date__item">{{ order.datetime_from }}</div>
                                            <div class="date__item">{{ order.datetime_to }}</div>
                                        </template>
                                    </div>
                                    <div class="container__place">
                                        <template v-if="order.is_return == false">
                                            <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg" alt="arrow"><span class="place__text">{{ order.place_from }}</span></div>
                                            <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg" alt="arrow"><span class="place__text">{{ order.place_to }}</span></div>
                                        </template>
                                        <template v-else>
                                            <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg" alt="arrow"><span class="place__text">{{ order.place_from }}</span></div>
                                            <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg" alt="arrow"><span class="place__text">{{ order.place_to }}</span></div>
                                            <div style='padding-bottom: 0px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_l.svg" alt="arrow"><span class="place__text">{{ order.place_from }}</span></div>
                                        </template>
                                    </div>
                                    <div class="container__patientHistory">
                                        <template v-if="order.is_return == false">
                                            <div style='padding-bottom: 6px;' class="patient__item">
                                                <img v-if="order.is_invalid" style='margin-right: 10px;margin-left:3px;' class="green-img" src="../assets/IMGS/SVG/invalidPeople.svg" alt="invalidPeople">
                                                <img v-if="order.is_child" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/child.svg" alt="child">
                                                <img v-if="order.is_pregnant" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/pregnantPeople.svg" alt="pregnantPeople">
                                                {{ order.patient_info }}
                                            </div>
                                            <div class="patient__item"><img class="green-img" src="../assets/IMGS/SVG/car.svg">{{ order.transport }}</div>
                                        </template>
                                        <template v-else>
                                            <div style='padding-bottom: 6px;' class="patient__item">
                                                <img v-if="order.is_invalid" style='margin-right: 10px;margin-left:3px;' class="green-img" src="../assets/IMGS/SVG/invalidPeople.svg" alt="invalidPeople">
                                                <img v-if="order.is_child" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/child.svg" alt="child">
                                                <img v-if="order.is_pregnant" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/pregnantPeople.svg" alt="pregnantPeople">
                                                {{ order.patient_info }}
                                            </div>
                                            <div style='padding-bottom: 28px;' class="patient__item"><img class="green-img" src="../assets/IMGS/SVG/car.svg" alt="car">{{ order.transport }}</div>
                                        </template>
                                    </div>
                                    <template v-if="order.is_return == false">
                                        <div class="container__Hsummary">{{ order.passengers }}</div>
                                    </template>
                                    <template v-else>
                                        <div style="margin-bottom: 56px;" class="container__Hsummary">{{ order.passengers }}</div>
                                    </template>
                                    <div class="container__buttonsMenu">
                                        <button style="background: #98A09F; transition: all 0.6s ease-in-out; position: relative; right: 0px; z-index: 1;" :id="'button_display_info_'+order.id"
                                            class="buttonsMenu__item" type="submit" value="details" v-on:click="displayAddinfo(order.id, 0)">
                                            <img class="item__img" src="../assets/IMGS/SVG/arrowMenu.svg" alt="arrow">
                                        </button>
                                        <div class="detailsItem" style="margin-right: 180px;" :id="'div_display_info_'+order.id">
                                            <input style="width: 60%; height: auto;" class="forminput" type="text" placeholder="Комментарий" :id="'order_set_comment_'+order.id" v-model="order.comment">
                                            <input @input="ev => order.price = tools.clickKeepNumber(ev.target.value,0)" style="width: 40%; height: auto;" class="forminput" type="text" placeholder="Цена"
                                                v-on:keyup.enter="displayAddinfo(order.id, 0)" :id="'order_set_price_'+order.id" v-model="order.price">
                                        </div>
                                        <button style="margin-left: 10px; background: #FA777E;" class="buttonsMenu__item" type="submit" value="cancel" :id="'button_cancel_'+order.id"
                                            v-on:click="dispatcherCancelOrder(order.id)"><img class="item__img" src="../assets/IMGS/SVG/cancel.svg" alt="exit"></button>
                                        <button style="margin-left: 10px;" class="buttonsMenu__submit" :class="{'blocked': order.button_blocked}" type="submit" value="confirm"  :id="'button_confirm_'+order.id"
                                            v-on:click="dispatcherConfirmOrder(order.id)">Подтвердить</button>
                                    </div>
                                </div>
                                <div class="order__underDetails gray">
                                    <!-- patientGender patientAge patientWeight mobility escort  -->
                                    <label class="underDetails__phone">
                                        <img v-if="order.patient_gender == 'male'" class="underDetails__svg" src="../assets/IMGS/SVG/who-02.svg" alt="gender">
                                        <img v-else class="underDetails__svg" src="../assets/IMGS/SVG/who-01.svg" alt="gender">
                                        {{order.patient_age}}
                                    </label>
                                    <div v-show="order.patient_weight != 'null'" class="patient_data_separator"></div>
                                    <label v-show="order.patient_weight != 'null'" class="underDetails__name">{{order.patient_weight}} кг</label>
                                    <div v-show="order.patient_mobility != ''" class="patient_data_separator"></div>
                                    <label v-show="order.patient_mobility != ''" class="underDetails__name">{{order.patient_mobility}}</label>
                                </div>
                                <template v-if="order.user_comment != ''">
                                    <div class="order__underDetails gray" style="height: fit-content;padding-top:5px;padding-bottom:5px">
                                        <label class="underDetails__phone" style="height: fit-content;text-align: left;word-break: break-all;">Комментарий: {{order.user_comment}}</label>
                                    </div>
                                </template>
                                <div class="underline__history"></div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex" id="in_pipeline_block" style=" width: 100%; display: none; color: #747474;">
                <div class="flex-item item_6" style="padding-left: 10px; flex-grow: 6;">
                    <div
                        style="flex-direction: row; display: flex; text-align: left; font-weight: 400; font-size: 12px; line-height: 16px; margin-bottom: 10px; padding: 15px;">
                        <div style="width: 5%;">No / Время</div>
                        <div style="width: 15%;">Когда</div>
                        <div style="width: 30%;" id="whereFromToDiv_processed">Откуда/Куда</div>
                        <div style="width: 25%;">Пациент/Транспорт</div>
                        <div style="width: 5%; text-align: center;">Сопровождающие</div>
                    </div>
                    <div v-if="!has_loaded_once" class="loading_text">
                        Данные загружаются, пожалуйста, подождите
                    </div>
                    <div v-else id="processed_orders">
                        <div v-for="order in old_orders" :key="'processed_orders_element'+order.id" :id="'processed_orders_element'+order.id">
                            <div :id="'progress_bar_' + order.id" class="d-flex" style="display:none;">
                                <div class="flex-item item_6" style="padding:0px;">
                                    <div :id="'progress_all_' + order.id" class="progress_all">
                                        <div class="progress_container">
                                            <div :id="'box1_'+order.id" class="progress_box">
                                                <p :id="'box1_number_'+order.id" class="progress_number">1</p>
                                                </div>
                                                <p :id="'box1_text_'+order.id" class="progress_text">Заказ подтвержден</p>
                                        </div>
                                        <div :id="'progress_rect1_' + order.id" class="progress_rect" style=""></div>
                                        <div class="progress_container">
                                            <div :id="'box2_'+order.id" class="progress_box">
                                                <p :id="'box2_number_'+order.id" class="progress_number">2</p>
                                                </div>
                                                <p :id="'box2_text_'+order.id" class="progress_text">Заказ запланирован</p>
                                        </div>
                                        <div :id="'progress_rect2_'+order.id" class="progress_rect"></div>
                                        <div class="progress_container">
                                            <div :id="'box3_'+order.id" class="progress_box" v-on:click="e => {order.status=='Запланирован' && dispatcherProgressOriginStatus(order.id, order.status)}">
                                                <p :id="'box3_number_'+order.id" class="progress_number">3</p>
                                                </div>
                                                <p :id="'box3_text_'+order.id" class="progress_text">Выезд исполнителя</p>
                                        </div>
                                        <div :id="'progress_rect3_' + order.id" class="progress_rect"></div>
                                        <div class="progress_container">
                                            <div :id="'box4_'+order.id" class="progress_box" v-on:click="e => {order.status=='Выезд' && dispatcherProgressOriginStatus(order.id, order.status)}">
                                                <p :id="'box4_number_'+order.id" class="progress_number">4</p>
                                                </div>
                                                <p :id="'box4_text_'+order.id" class="progress_text">Заказ выполняется</p>
                                        </div>
                                        <div :id="'progress_rect4_' + order.id" class="progress_rect"></div>
                                        <div class="progress_container">
                                            <div :id="'box5_'+order.id" class="progress_box" v-on:click="e => {order.status=='Выполняется' && dispatcherProgressOriginStatus(order.id, order.status)}">
                                                <p :id="'box5_number_'+order.id" class="progress_number">5</p>
                                                </div>
                                                <p :id="'box5_text_'+order.id" class="progress_text">Заказ выполнен</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="superviser__history_item">
                                <div class="container__history">
                                    <div class="container__itemID">
                                        <template v-if="order.is_return == false">
                                            <div style='padding-bottom: 6px;' class="itemID">{{ order.id }}</div>
                                            <div class="itemID__time">{{ order.time }}</div>
                                        </template>
                                        <template v-else>
                                            <div style='padding-bottom: 6px;' class="itemID">{{ order.id }}</div>
                                            <div style='padding-bottom: 28px;' class="itemID__time">{{ order.time }}</div>
                                        </template>
                                    </div>
                                    <div class="container__date">
                                        <template v-if="order.is_return == false">
                                            <div style='padding-bottom: 28px;' class="date__item">{{ order.datetime_from }}</div>
                                        </template>
                                        <template v-else-if="order.is_wait == true">
                                            <div style='padding-bottom: 56px;' class="date__item">{{ order.datetime_from }}</div>
                                        </template>
                                        <template v-else>
                                            <div style='padding-bottom: 34px;' class="date__item">{{ order.datetime_from }}</div>
                                            <div class="date__item">{{ order.datetime_to }}</div>
                                        </template>
                                    </div>
                                    <div class="container__place">
                                        <template v-if="order.is_return == false">
                                            <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg" alt="arrow"><span class="place__text">{{ order.place_from }}</span></div>
                                            <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg" alt="arrow"><span class="place__text">{{ order.place_to }}</span></div>
                                        </template>
                                        <template v-else>
                                            <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg" alt="arrow"><span class="place__text">{{ order.place_from }}</span></div>
                                            <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg" alt="arrow"><span class="place__text">{{ order.place_to }}</span></div>
                                            <div style='padding-bottom: 0px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_l.svg" alt="arrow"><span class="place__text">{{ order.place_from }}</span></div>
                                        </template>
                                    </div>
                                    <div class="container__patientHistory">
                                        <template v-if="order.is_return == false">
                                            <div style='padding-bottom: 6px;' class="patient__item">
                                                <img v-if="order.is_invalid" style='margin-right: 10px;margin-left:3px;' class="green-img" src="../assets/IMGS/SVG/invalidPeople.svg" alt="invalidPeople">
                                                <img v-if="order.is_child" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/child.svg" alt="child">
                                                <img v-if="order.is_pregnant" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/pregnantPeople.svg" alt="pregnantPeople">
                                                {{ order.patient_info }}
                                            </div>
                                            <div class="patient__item"><img class="green-img" src="../assets/IMGS/SVG/car.svg">{{ order.transport }}</div>
                                        </template>
                                        <template v-else>
                                            <div style='padding-bottom: 6px;' class="patient__item">
                                                <img v-if="order.is_invalid" style='margin-right: 10px;margin-left:3px;' class="green-img" src="../assets/IMGS/SVG/invalidPeople.svg" alt="invalidPeople">
                                                <img v-if="order.is_child" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/child.svg" alt="child">
                                                <img v-if="order.is_pregnant" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/pregnantPeople.svg" alt="pregnantPeople">
                                                {{ order.patient_info }}
                                            </div>
                                            <div style='padding-bottom: 28px;' class="patient__item"><img class="green-img" src="../assets/IMGS/SVG/car.svg" alt="car">{{ order.transport }}</div>
                                        </template>
                                    </div>
                                    <template v-if="order.is_return == false">
                                        <div class="container__Hsummary">{{ order.passengers }}</div>
                                    </template>
                                    <template v-else>
                                        <div style="margin-bottom: 56px;" class="container__Hsummary">{{ order.passengers }}</div>
                                    </template>
                                    <div class="container__buttonsMenu">
                                        <template v-if="translateStatusIntoShorter(order.status) != 'Отмена' && translateStatusIntoShorter(order.status) != 'Просрочен'">
                                            <button style="background: #98A09F; transition: all 0.6s ease-in-out; position: relative; right: 0px; z-index: 1;" :id="'button_display_info_processed_'+order.id"
                                                class="buttonsMenu__item" type="submit" value="details" v-on:click="displayAddinfo(order.id, 1)"><img class="item__img" src="../assets/IMGS/SVG/arrowMenu.svg" alt="arrow"></button>
                                            <div class="detailsItem" style="margin-right: 215px;" :id="'div_display_info_processed_'+order.id">
                                                <input disabled style="width: 60%; height: auto;" class="forminput" type="text" placeholder="Комментарий" :value="order.owner_comment" :id="'order_set_comment_processed_'+order.id">
                                                <input disabled style="width: 40%; height: auto;" class="forminput" type="text"
                                                    v-on:keyup.enter="displayAddinfo(order.id, 1)" placeholder="Цена" :value="order.order_price" :id="'order_set_price_processed_'+order.id">
                                            </div>
                                            <button v-if="translateStatusIntoShorter(order.status) != 'Подтвержден'"
                                                style="margin-left: 10px; background: #98A09F;" class="buttonsMenu__item" type="submit" value="pause"
                                                v-on:click="dispatcherToggleStopOrder(order.id, order.status)">
                                                <img v-if="order.status != 'Приостановлен'" id="pause_order" class="item__img" src="../assets/IMGS/SVG/pause.svg" alt="play">
                                                <img v-else id="pause_order" class="item__img" src="../assets/IMGS/SVG/ic_play.svg" alt="icplay">
                                            </button>
                                            <button style="margin-left: 10px; background: #FA777E;" class="buttonsMenu__item" type="submit" value="cancel" :id="'button_cancel_processed_'+order.id"
                                                v-on:click="dispatcherCancelOrder(order.id)"><img class="item__img" src="../assets/IMGS/SVG/cancel.svg" alt="exit"></button>
                                        </template>

                                        <template v-if="translateStatusIntoShorter(order.status) == 'Подтвержден'">
                                            <button style="margin-left: 10px;" class="buttonsMenu__status gray" type="submit" value="confirm"  :id="'button_confirm_processed_'+order.id"
                                            v-on:click="dispatcherToggleProgressBar(order.id, order.status)">{{translateStatusIntoShorter(order.status)}}</button>
                                        </template>
                                        <template v-else-if="translateStatusIntoShorter(order.status) == 'Отмена' && order.comment">
                                            <HoverIcon :key="reloadMark">
                                                <template v-slot:hoverItem>
                                                    <span style="margin-left: 10px;" class="buttonsMenu__status canceled">{{ translateStatusIntoShorter(order.status) }}</span>
                                                </template>
                                                <template v-slot:hoverText>
                                                    Причина отказа: {{ order.comment }}
                                                </template>
                                            </HoverIcon>
                                        </template>
                                        <template v-else-if="translateStatusIntoShorter(order.status) == 'Отмена' || translateStatusIntoShorter(order.status) == 'Просрочен'">
                                            <button style="margin-left: 10px;background-color: #FFCACD !important;color: #98A09F !important;cursor:default" class="buttonsMenu__status" type="submit" value="confirm"  :id="'button_confirm_processed_'+order.id">
                                                {{translateStatusIntoShorter(order.status)}}</button>
                                        </template>
                                        <template v-else>
                                            <button style="margin-left: 10px;" class="buttonsMenu__status green" type="submit" value="confirm"  :id="'button_confirm_processed_'+order.id"
                                            v-on:click="dispatcherToggleProgressBar(order.id, order.status)">{{translateStatusIntoShorter(order.status)}}</button>
                                        </template>
                                    </div>
                                </div>
                                <template v-if="translateStatusIntoShorter(order.status) != 'Подтвержден'">
                                    <div class="order__underDetails green">
                                        <!-- patientGender patientAge patientWeight mobility escort  -->
                                        <label class="underDetails__phone">
                                            <img v-if="order.patient_gender == 'male'" class="underDetails__svg" src="../assets/IMGS/SVG/who-02.svg" alt="gender">
                                            <img v-else class="underDetails__svg" src="../assets/IMGS/SVG/who-01.svg" alt="gender">
                                            {{order.patient_age}}
                                        </label>
                                        <div v-show="order.patient_weight != 'null'" class="patient_data_separator"></div>
                                        <label v-show="order.patient_weight != 'null'" class="underDetails__name">{{order.patient_weight}} кг</label>
                                        <div v-show="order.patient_mobility != ''" class="patient_data_separator"></div>
                                        <label v-show="order.patient_mobility != ''" class="underDetails__name">{{order.patient_mobility}}</label>
                                    </div>
                                    <div class="order__underDetails green">
                                        <label class="underDetails__phone"><img class="underDetails__svg" src="../assets/IMGS/SVG/phone_2.svg" alt="phone">{{order.contact_phone}}</label>
                                        <label class="underDetails__name"><img class="underDetails__svg" src="../assets/IMGS/SVG/profile.svg" alt="profile">{{order.contact_name}}</label>
                                    </div>
                                    <template v-if="order.user_comment != ''">
                                        <div class="order__underDetails green" style="height: fit-content;padding-top:5px;padding-bottom:5px">
                                            <label class="underDetails__phone" style="height: fit-content;text-align: left;word-break: break-all;">Комментарий: {{order.user_comment}}</label>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="order__underDetails gray">
                                        <label class="underDetails__phone">
                                            <img v-if="order.patient_gender == 'male'" class="underDetails__svg" src="../assets/IMGS/SVG/who-02.svg" alt="gender">
                                            <img v-else class="underDetails__svg" src="../assets/IMGS/SVG/who-01.svg" alt="gender">
                                            {{order.patient_age}}
                                        </label>
                                        <div v-show="order.patient_weight != 'null'" class="patient_data_separator"></div>
                                        <label v-show="order.patient_weight != 'null'" class="underDetails__name">{{order.patient_weight}} кг</label>
                                        <div v-show="order.patient_mobility != ''" class="patient_data_separator"></div>
                                        <label v-show="order.patient_mobility != ''" class="underDetails__name">{{order.patient_mobility}}</label>
                                    </div>
                                    <template v-if="order.user_comment != ''">
                                        <div class="order__underDetails gray" style="height: fit-content;padding-top:5px;padding-bottom:5px">
                                            <label class="underDetails__phone" style="height: fit-content;text-align: left;word-break: break-all;">Комментарий: {{order.user_comment}}</label>
                                        </div>
                                    </template>
                                </template>
                                <div class="underline__history"></div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="flex-item item_2_space item_space_border_right" style="min-width: 5vw;max-width: 5vw;"></div>
</div>
</template>

<script>
import $ from 'jquery';
import tools from '@/assets/js/tools.js';
import popup from './ModalComponent.vue';
import HoverIcon from './HoverInfoComponent.vue';

var non_processed_orders = [];
var orders_in_progress = [];
var status_dict = {"Подтвержден" : 0, "Запланирован" : 1, "Выезд" : 2, "Выполняется" : 3, "Выполнен" : 4};
var status_str_to_num = {"Любой" : -1, "Создан" : 0, "Подтвержден" : 1, "Запланирован" : 2, "Выезд" : 3, "Выполняется" : 4, "Выполнен" : 5};

export default {
    name: 'SuperviserPage',
    el: '#new_orders_page',
    components: {
        'PopupWindow': popup,
        'HoverIcon': HoverIcon
    },
    data() {
      return {
        modal: {
            popupName: 'default',
            header: 'Подтверждение',
            info: '',
            button: '',
            color: '#0ECCAA',
            button2: 'Отмена',
            callback: function() { }
        },
        isVisiblePopup: false,
        new_orders: non_processed_orders,
        old_orders: orders_in_progress,
        translateStatusIntoShorter: tools.translateStatusIntoShorter,
        getNowDate: tools.getNowDate,
        setNowDay: tools.setNowDay,
        setNowMonth: tools.setNowMonth,
        setLastWeek: tools.setLastWeek,
        setToDefault: tools.setToDefault,
        has_loaded_once: false,
        tools: tools,
        visibleFilters: true,
        PageName : 'notWRequests',
        reloadMark: 0,
      };
    },
    mounted() {
        var vm = this;
        vm.PageName = 'notWRequests';
        tools.addAutocompletion('search_adress', "addresses")
        document.getElementById("non_processed_button").onclick = (function () {
            let new_width = $("#notWRequests").position().left - $("#non_processed_button").position().left + $("#notWRequests").outerWidth() + parseInt($("#notWRequests").css("margin-left"));
            document.getElementById("child").animate([
                { marginLeft: document.getElementById("child").style.marginLeft, width: document.getElementById("child").style.width },
                { marginLeft: "0px", width: new_width }
            ], {
                duration: 200,
            });
            $("#child").css("margin-left", 0)
            $("#child").css("width", new_width)
            document.getElementById("non_processed_block").style.display = "flex";
            document.getElementById("in_pipeline_block").style.display = "none";
            document.getElementById("non_processed_button").style.cursor = "default";
            document.getElementById("in_pipeline_button").style.cursor = "pointer";
            $("#non_processed_button").addClass("focused");
            $("#in_pipeline_button").removeClass("focused");
            $("#filter_status").css("display", 'none');
            vm.PageName = 'notWRequests';
        });
        document.getElementById("in_pipeline_button").onclick = (function () {
            vm.reloadMark += 1
            let delta_x = $("#in_pipeline_button").position().left - $("#non_processed_button").position().left;
            let new_width = $("#inWorkRequests").position().left - $("#in_pipeline_button").position().left + $("#inWorkRequests").outerWidth() + parseInt($("#inWorkRequests").css("margin-left"));
            document.getElementById("child").animate([
                { marginLeft: document.getElementById("child").style.marginLeft, width: document.getElementById("child").style.width },
                { marginLeft: delta_x, width: new_width }
            ], {
                duration: 200,
            });
            $("#child").css("margin-left", delta_x)
            $("#child").css("width", new_width)
            document.getElementById("non_processed_block").style.display = "none";
            document.getElementById("in_pipeline_block").style.display = "flex";
            document.getElementById("non_processed_button").style.cursor = "pointer";
            document.getElementById("in_pipeline_button").style.cursor = "default";
            $("#non_processed_button").removeClass("focused");
            $("#in_pipeline_button").addClass("focused");
            $("#filter_status").css("display", 'flex');
            vm.PageName = 'inWorkRequests';
        });
        $("#non_processed_button").click();

        const url_params = new URLSearchParams(window.location.search);
        const redirect_to = url_params.get('redirect');
        if (redirect_to == "in_work") $('#in_pipeline_button').click();

        this.reRender();
        setInterval(() => {
            this.reRender();
        }, 5000);
    },
    methods: {
        reFiltering() {
            this.setToDefault()
            this.reRender();
        },
        flexFilters(){
            if (this.visibleFilters === true) {
                if (this.PageName === 'inWorkRequests') {
                    $("#filter_status").css('display', 'none')
                }
                $("#filter__time").css("display", 'none');
                $("#filter__type").css("display", 'none');
                $("#filter__patient").css("display", 'none');
                $("#filter__region").css("display", 'none');
                $("#filter__adress").css("display", 'none');
                $("#superviser__control").css("width", '50px');
                $("#superviser__control").css("min-width", '50px')
                $("#filter__head").css("width", '28px')
                $("#filter_zone_item").css("opacity", '0');
                $("#filter_zone_item").css("display", 'none')
                this.visibleFilters = false;
            } else if (this.visibleFilters === false) {
                if (this.PageName === 'inWorkRequests') {
                    $("#filter_status").css('display', 'flex')
                }
                $("#filter__time").css("display", 'flex');
                $("#filter__type").css("display", 'flex');
                $("#filter__patient").css("display", 'flex');
                $("#filter__region").css("display", 'flex');
                $("#filter__adress").css("display", 'flex');
                $("#superviser__control").css("width", '256px');
                $("#superviser__control").css("min-width", '256px');
                $("#filter__head").css("width", '234px')
                $("#filter_zone_item").css("opacity", '1');
                $("#filter_zone_item").css("display", 'flex')
                this.visibleFilters = true;
            }
        },
        dispatcherConfirmOrder(el) {
            var vm = this;
            if ($("#button_confirm_" + el).hasClass("blocked")) return;
            var set_comment = $("#order_set_comment_" + el).val();
            var set_price = $("#order_set_price_" + el).val();
            $.ajax({
                type: "GET",
                xhrFields: { withCredentials: true },
                url: global.BACKEND_URL + `/new_orders/confirm_order?order_id=${el}&comment=${set_comment}&price=${set_price}`,
                success: function () { console.log("confirmed!"); vm.reRender(); },
                error: function () { console.log("Not success :(") },
                dataType: "text",
                contentType: "application/json"
            });
        },
        dispatcherToggleStopOrder(el_id, el_status) {
            var vm = this;
            if(el_status != 'Приостановлен') {
                $.ajax({
                    type: "GET",
                    xhrFields: { withCredentials: true },
                    url: global.BACKEND_URL + `/new_orders/stop_order?order_id=${el_id}`,
                    success: function () { console.log("stopped!"); vm.reRender(); },
                    error: function () { console.log("Not success :(") },
                    dataType: "text",
                    contentType: "application/json"
                });
            }
            else {
                $.ajax({
                    type: "GET",
                    xhrFields: { withCredentials: true },
                    url: global.BACKEND_URL + `/new_orders/continue_order?order_id=${el_id}`,
                    success: function () { console.log("stopped!"); vm.reRender(); },
                    error: function () { console.log("Not success :(") },
                    dataType: "text",
                    contentType: "application/json"
                });
            }
        },
        dispatcherCancelOrder(el) {
            var vm = this;
            vm.modal = {
                popupName: 'cancelOrderDis',
                header: 'Отмена заказа №' + el,
                info: 'Укажите, причину отмены заказа',
                button: 'Да',
                button2: 'Отмена',
                color: '#0ECCAA',
                callback: function(element, comment) {
                    if (element === 'Да' && comment != '' ) {
                        $.ajax({
                            type: "GET",
                            xhrFields: { withCredentials: true },
                            url: global.BACKEND_URL + `/new_orders/cancel_order?order_id=${el}&comment=${comment}`,
                            success: function () { console.log("canceled!"); vm.reRender(); },
                            error: function () { console.log("Not success :(") },
                            dataType: "text",
                            contentType: "application/json"
                        });
                    }

                }
            }
            vm.isVisiblePopup = true;
        },
        dispatcherProgressOriginStatus(el_id, el_status) {
            var vm = this;
            var statuses = ["", "Подтвержден", "Запланирован", "Выезд", "Выполняется", "Выполнен"]
            var new_status_index = statuses.findIndex(e => e == el_status) + 1;
            if (new_status_index == statuses.length - 1) {
                vm.modal = {
                    header: 'Информация',
                    info: 'Заказ выполнен!',
                    button: 'ОК',
                    color: '#0ECCAA'
                },
                vm.isVisiblePopup = true;
            }
            $.ajax({
                type: "GET",
                xhrFields: { withCredentials: true },
                url: global.BACKEND_URL + `/new_orders/set_origin_status?order_id=${el_id}&new_status=${new_status_index}`,
                success: function () { console.log("continued!"); vm.reRender(); },
                error: function () { console.log("Not success :(") },
                dataType: "text",
                contentType: "application/json"
            });
            this.dispatcherToggleProgressBar(el_id, el_status);
        },
        dispatcherToggleProgressBar(el_id, el_status) {
            const status_num = status_dict[el_status];
            if (status_num == 0) return;
            for (let i = 1; i <= status_num + 1; i++) {
                $('#box' + i + '_' + el_id).css("background-color", "#ee6870");
                $('#box' + i + '_' + el_id).css("border-color", "#ee6870");
                $('#box' + i + '_' + el_id).css("cursor", "auto");
                $('#box' + i + '_number_' + el_id).css("color", "#fff");
                $('#box' + i + '_text_' + el_id).css("color", "#ee6870");
                if (i != 1) {
                    $('#progress_rect' + (i - 1) + '_' + el_id).css("background-color", "#ee6870");
                }
            }
            $('#box' + (status_num + 2) + '_' + el_id).css("cursor", "pointer");
            const bar = document.getElementById("progress_bar_" + el_id);
            if (bar.style.display == 'none') {
                bar.style.display = 'flex';
            }
            else {
                bar.style.display = 'none';
            }

        },
        displayAddinfo(order_id, type_page) {
            var vm = this;
            var name_suffix = "";
            if (type_page == 1) {
                name_suffix += "processed_";
            }
            var delta_x = window.innerWidth - $("#button_cancel_" + name_suffix + order_id).offset().left + 10;
            $("#div_display_info_" + name_suffix + order_id).css("right", delta_x);
            $("#div_display_info_" + name_suffix + order_id).css("height", $("#button_cancel_" + name_suffix + order_id).css("height"));
            if ($("#button_display_info_" + name_suffix + order_id).hasClass("open")) {
                $("#button_display_info_" + name_suffix + order_id).removeClass("open");
                $("#button_display_info_" + name_suffix + order_id).css("right", 0);
                $("#button_display_info_" + name_suffix + order_id).css("border-radius", '5px');
                $("#div_display_info_" + name_suffix + order_id).css("width", 0);
                $("#div_display_info_" + name_suffix + order_id).css("opacity", 0);
                $("#div_display_info_" + name_suffix + order_id).css("right", 'unset');
                $("#div_display_info_" + name_suffix + order_id).css("position", 'absolute');
                $("#div_display_info_" + name_suffix + order_id).css("visibility", 'hidden');

                if (type_page == 0 && document.getElementById(`order_set_price_${order_id}`).value != "") {
                    vm.new_orders.forEach(order_iter => {
                        if (order_iter["id"] == order_id) {
                            order_iter["button_blocked"] = false;
                        }
                    });
                }
                else {
                    vm.new_orders.forEach(order_iter => {
                        if (order_iter["id"] == order_id) {
                            order_iter["button_blocked"] = true;
                        }
                    });
                }
            } else {
                $("#div_display_info_" + name_suffix + order_id).css("display", 'flex');
                $("#button_display_info_" + name_suffix + order_id).addClass("open");
                $("#button_display_info_" + name_suffix + order_id).css("right", 500);
                $("#div_display_info_" + name_suffix + order_id).css("width", 500);
                $("#div_display_info_" + name_suffix + order_id).css("right", 'unset');
                $("#button_display_info_" + name_suffix + order_id).css("border-radius", '5px 0px 0px 5px');
                $("#div_display_info_" + name_suffix + order_id).css("opacity", 1);
                $("#div_display_info_" + name_suffix + order_id).css("visibility", 'visible');
            }
        },
        reRender(ev) {
            if (ev) {
                // no propagation
                if (ev.explicitOriginalTarget == ev.target) {
                    return
                }
            }
            var vm = this;
            vm.flexFilters();
            vm.flexFilters();
            const dateFirst = document.getElementById("first__date");
            const dateSecond = document.getElementById("second__date");
            const timeFirst = document.getElementById("first__time");
            const timeSecond = document.getElementById("second__time");

            function formatDate(date, time, if_first) {
                var current_date;
                var current_time;
                if (date.value == "") {
                    current_date = if_first ? '1970-01-01' : '2970-01-01';
                }
                else {
                    current_date = date.value;
                }
                if (time.value == "") {
                    current_time = if_first ? '00:00' : '23:59';
                }
                else {
                    current_time = time.value;
                }
                var dateTmp = new Date(`${current_date}T${current_time}`);
                var formattedDate = dateTmp.toLocaleString("sv-SE", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false
                }).replace(",", "").replace(/\//g, "-");
                return formattedDate;
                // Output: "2023-02-02 12:30"
            }
            var formattedDateFirst = formatDate(dateFirst, timeFirst, true);
            var formattedDateSecond = formatDate(dateSecond, timeSecond, false);
            var typeService = '';
            if (document.getElementById('veh__check_1').checked) {
                if (document.getElementById('type__check_1').checked) {
                    typeService += '0';
                }
                else {
                    if (document.getElementById('type__check_2').checked) {
                        typeService += '12';
                    }
                    if (document.getElementById('type__check_3').checked) {
                        typeService += '13';
                    }
                    if (document.getElementById('type__check_4').checked) {
                        typeService += '14';
                    }
                }
            }
            else if (document.getElementById('veh__check_2').checked) {
                typeService += '41';
            }
            else if (document.getElementById('veh__check_3').checked) {
                typeService += '21';
            }
            else if (document.getElementById('veh__check_4').checked) {
                typeService += '31';
            }
            else {
                typeService += '0';
            }

            var typePatient = "";
            if (document.getElementById('patient__check_1').checked) {
                typePatient += '1';
            }
            if (document.getElementById('patient__check_2').checked) {
                typePatient += '2'
            }
            if (document.getElementById('patient__check_3').checked) {
                typePatient += '3'
            }
            if (typePatient == "") {
                typePatient = "0";
            }
            var address_filter = document.getElementById('search_adress').value;
            var status_filter = status_str_to_num[document.getElementById("order_status").innerText];
            $.ajax({
                type: "GET",
                xhrFields: { withCredentials: true },
                url: global.BACKEND_URL + `/new_orders/getActiveOrders?status=${status_filter}&dateStart=${formattedDateFirst}`
                    + `&dateEnd=${formattedDateSecond}&typeService=${typeService}&typePatient=${typePatient}`
                    + `&myRegion=${document.getElementById("toggle_region").checked}&address=${address_filter}`,

                success: function (data) {
                    vm.has_loaded_once = true;
                    non_processed_orders = [];
                    orders_in_progress = [];
                    data['unprocessedOrders'].forEach(singular_order => {
                        var my_comment_el = document.getElementById("order_set_comment_" + singular_order["idOrder"]);
                        var my_comment_val = "";
                        if (my_comment_el) my_comment_val = my_comment_el.value;
                        var my_price_el = document.getElementById("order_set_price_" + singular_order["idOrder"]);
                        var my_price_val = "";
                        if (my_price_el) my_price_val = my_price_el.value;
                        var blocked_val = true;
                        for (var i = 0; i < vm.new_orders.length; i++) {
                            if (vm.new_orders[i]["id"] == singular_order["idOrder"]) {
                                blocked_val = vm.new_orders[i]["button_blocked"];
                                break;
                            }
                        }
                        non_processed_orders = non_processed_orders.concat(
                        [{
                            "id": singular_order["idOrder"],
                            "time": singular_order["orderDate"],
                            "datetime_from": singular_order["orderDateStart"],
                            "datetime_to": singular_order["orderDateBack"],
                            "place_from": singular_order["regionFrom"] + ", " + singular_order["addressStart"] +
                                tools.addrSuffixElevatorFloorDispatcher((singular_order["isElevatorFrom"]==='true'), (singular_order["isCargoElevatorFrom"]==='true'),
                                                              parseInt(singular_order["floorFrom"])),
                            "place_to": singular_order["regionTo"] + ", " + singular_order["addressFinish"] +
                                tools.addrSuffixElevatorFloorDispatcher((singular_order["isElevatorTo"]==='true'), (singular_order["isCargoElevatorTo"]==='true'),
                                                              parseInt(singular_order["floorTo"])),
                            "passengers": singular_order["numPassenger"],
                            "patient_info": ((singular_order["escort"] == "Не требуется") ? "Сопровождение: нет" : singular_order["escort"]),
                            "transport": singular_order["transport"],
                            "is_return": singular_order["isReturn"] == "true",
                            "is_wait" : singular_order["isWait"] == "true",
                            "status": singular_order["status"],
                            "is_child" : singular_order["isChild"] == "true",
                            "is_pregnant" : singular_order["isPregnant"] == "true",
                            "is_invalid" : singular_order["isInvalid"] == "true",
                            "comment" : my_comment_val,
                            "user_comment": singular_order["patientInitComment"],
                            "price" : my_price_val,
                            "button_blocked" : blocked_val,
                            "patient_gender": singular_order["patientGender"],
                            "patient_age": singular_order["patientAge"],
                            "patient_weight": singular_order["patientWeight"],
                            "patient_mobility": singular_order["mobility"],
                            "patient_escort": singular_order["escort"],
                        }])
                    })
                    data['ordersInProgress'].forEach(singular_order => {
                        orders_in_progress = orders_in_progress.concat(
                            [{
                                "id": singular_order["idOrder"],
                                "time": singular_order["orderDate"],
                                "datetime_from": singular_order["orderDateStart"],
                                "datetime_to": singular_order["orderDateBack"],
                                "place_from": singular_order["regionFrom"] + ", " + singular_order["addressStart"] +
                                    tools.addrSuffixElevatorFloorDispatcher((singular_order["isElevatorFrom"]==='true'), (singular_order["isCargoElevatorFrom"]==='true'),
                                                                            parseInt(singular_order["floorFrom"])),
                                "place_to": singular_order["regionTo"] + ", " + singular_order["addressFinish"] +
                                    tools.addrSuffixElevatorFloorDispatcher((singular_order["isElevatorTo"]==='true'), (singular_order["isCargoElevatorTo"]==='true'),
                                                                            parseInt(singular_order["floorTo"])),
                                "passengers": singular_order["numPassenger"],
                                "patient_info": ((singular_order["escort"] == "Не требуется") ? "Сопровождение: нет" : singular_order["escort"]),
                                "transport": singular_order["transport"],
                                "is_return": singular_order["isReturn"] == "true",
                                "is_wait" : singular_order["isWait"] == "true",
                                "status": singular_order["status"],
                                "is_child" : singular_order["isChild"] == "true",
                                "is_pregnant" : singular_order["isPregnant"] == "true",
                                "is_invalid" : singular_order["isInvalid"] == "true",
                                "contact_phone": singular_order["contactNum"],
                                "contact_name": singular_order["contactName"] + ", " + ((singular_order["patientWeight"] != 'null') ? ("вес " + singular_order["patientWeight"] + " кг,") : "") + " возраст " + singular_order["patientAge"] + " " +
                                    tools.ageStr(parseInt(singular_order["patientAge"])),
                                "owner_comment": singular_order["owner_comment"],
                                "user_comment": singular_order["patientInitComment"],
                                "order_price": singular_order["order_price"],
                                "comment": singular_order["comment"],
                                "patient_gender": singular_order["patientGender"],
                                "patient_age": singular_order["patientAge"],
                                "patient_weight": singular_order["patientWeight"],
                                "patient_mobility": singular_order["mobility"],
                                "patient_escort": singular_order["escort"],
                            }]
                        )
                    })
                    vm.new_orders = non_processed_orders;
                    vm.old_orders = orders_in_progress;
                    $("#notWRequests").text(vm.new_orders.length);
                    $("#inWorkRequests").text(vm.old_orders.length);
                },
                error: function () { console.log("Not success :(") },
                dataType: "json",
                contentType: "application/json"
            })
            this.currentKey += 1;
        }
    }
}
</script>

<style lang="css" scoped src="@/assets/css/dispatcher_orders.css"></style>
